import styled from 'styled-components';
import { space, color, textAlign } from 'styled-system';
import { ThemeInterface } from '../theme/ThemeInterface';
import { StyledSystemProps } from '../theme/StyledSystemProps';

type Props = StyledSystemProps & {
  pointer?: boolean;
};

const ListItem = styled.li<Props>`
  ${space};
  ${color};
  ${textAlign};
  font-size: ${(props: ThemeInterface) => props.theme.fontSizes[0]};
  text-transform: ${(props: ThemeInterface) => props.textTransform || 'none'};
  &:hover {
    cursor: ${(props: ThemeInterface) => (props.pointer ? 'pointer' : 'default')};
  }
`;

export default ListItem;



// WEBPACK FOOTER //
// ./src/typography/LI.ts